import colors from "shared/styles/colors";
import styled from "styled-components";
import { Label } from "./Form";

interface IWarningContainerProps {
    disabled?: boolean;
}

export const WarningContainer = styled.div<IWarningContainerProps>`
    ${props => props.disabled ? "" :
        `border-left: solid 3px ${colors.orangePrimary};
        margin-bottom: 24px;
        padding-left: 15px;
        .alert-label, ${Label}  {
            position: relative;
            padding-left: 30px;
            color: ${colors.orangePrimary};
            font-size: var(--header-3-font-size);
            margin-bottom: 5px;
        }

        .alert-label::before {
            position: absolute;
            margin-top: -1px;
            margin-left: -30px;
            color: ${colors.orangePrimary};
            font-family: 'coolicons' !important;
            speak: never;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            font-size: var(--header-2-font-size);
        
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            content: \"\\e91f\";
        }

        .alert-content {
            font-size: 1rem;
        }`}
`;

export const ErrorContainer = styled.div`
    border-left: solid 3px ${colors.warningPrimary};
    margin-bottom: 24px;
    padding-left: 10px;
    .alert-warning {
        margin-bottom: 14px;
    }
    .alert-label {
        color: ${colors.warningDark};
        font-size: var(--header-3-font-size);
        margin-bottom: 5px;
    }
    .alert-label::before {
        font-family: 'coolicons' !important;
        speak: never;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
      
        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        content: \"\\e91f\";
    }
    .alert-content {
        font-size: 1rem;
    }
`;

export const InfoContainer = styled.div`
    border-left: solid 3px ${colors.bluePrimary};
    margin-bottom: 24px;
    padding-left: 10px;
    .alert-warning {
        margin-bottom: 14px;
    }
    .alert-label {
        color: ${colors.bluePrimary};
        font-size: var(--header-3-font-size);
        margin-bottom: 5px;
    }
    .alert-label::before {
        font-family: 'coolicons' !important;
        speak: never;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
      
        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        content: \"\\e91f\";
    }
    .alert-content {
        font-size: 1rem;
    }

`